import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './Firebase';
import { auth } from './Firebase';
import Login from './pages/Login';
import Home from './pages/Home';
import Waiting from './pages/Waiting';
import CircularProgress from '@mui/material/CircularProgress';

function App() {
  const [user, setUser] = useState(null);
  const [isApproved, setIsApproved] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);

      if (currentUser) {
        const docRef = doc(db, 'users', currentUser.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setIsApproved(docSnap.data().isApproved);
        } else {
          setIsApproved(false);
        }
      } else {
        setIsApproved(null);
      }

      setChecking(false);
    });

    return () => unsubscribe();
  }, []);

  if (checking) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#f9f9f9'
      }}>
        <CircularProgress size={40} />
      </div>
    );
  }


  
  return (
    <Router>
      <Routes>
        {/* Always available */}
        <Route path="/login" element={<Login />} />

        {/* Waiting room for unapproved users */}
        <Route
          path="/waiting"
          element={
            user && isApproved === false ? (
              <Waiting />
            ) : (
              <Navigate to={user ? '/' : '/login'} replace />
            )
          }
        />

        {/* Main App Route (Home) */}
        <Route
          path="/"
          element={
            !user ? (
              <Navigate to="/login" replace />
            ) : isApproved === false ? (
              <Navigate to="/waiting" replace />
            ) : (
              <Home />
            )
          }
        />

        {/* Fallback for any unknown routes */}
        <Route
          path="*"
          element={<Navigate to="/" replace />}
        />
      </Routes>
    </Router>
  );
}

export default App;
